import { ParsedTab } from '../explore/components/tabs/store'
import { BreadcrumbStickyContainer } from '../explore/components/tabs/dashboard-breadcrumb'
import { Breadcrumb, BreadcrumbItem } from '~/sotano-kit/primitives/breadcrumb'

export const SiteTabContent = ({
  parsedTab,
}: {
  parsedTab: Extract<ParsedTab, { type: 'site' }>
}) => {
  return (
    <>
      <BreadcrumbStickyContainer>
        <Breadcrumb>
          <BreadcrumbItem active={false}>Site</BreadcrumbItem>
        </Breadcrumb>
      </BreadcrumbStickyContainer>
      <SiteContent siteId={parsedTab.siteId} />
    </>
  )
}

const SiteContent = ({ siteId }: { siteId: string }) => {
  return <div>Site {siteId}</div>
}
